import { format, formatRelative } from 'date-fns';
import { pt } from 'date-fns/locale';

export function RelativeDate({ date }: { date?: string }) {
    if (typeof date === 'undefined') {
        return "";
    }
    return formatRelative(new Date(date), new Date(), { locale: pt });
}

export function DataBrasil({ date }: { date: string }) {
    return format(date, 'dd/MM/yy', { locale: pt });
}
